var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7109 31.3876V8.7563C41.7109 6.5063 39.8734 4.83755 37.6422 5.02505H37.5297C33.5922 5.36255 27.6109 7.3688 24.2734 9.4688L23.9547 9.67505C23.4109 10.0125 22.5109 10.0125 21.9672 9.67505L21.4984 9.3938C18.1609 7.31255 12.1984 5.32505 8.26094 5.0063C6.02969 4.8188 4.21094 6.5063 4.21094 8.73755V31.3876C4.21094 33.1876 5.67344 34.875 7.47344 35.1L8.01719 35.1751C12.0859 35.7188 18.3672 37.7813 21.9672 39.7501L22.0422 39.7875C22.5484 40.0688 23.3547 40.0688 23.8422 39.7875C27.4422 37.8 33.7422 35.7188 37.8297 35.1751L38.4484 35.1C40.2484 34.875 41.7109 33.1876 41.7109 31.3876Z",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9609 10.2937V38.4187",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9922 15.9187H10.7734",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3984 21.5437H10.7734",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationListIcon);
export default __webpack_public_path__ + "static/media/EducationListIcon.435ffb84d7382881a2d3ccd8734db87b.svg";
export { ForwardRef as ReactComponent };